/*
* 账户信息组件
*/

import { Component, useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Modal,
    Space,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    winWidth,
    Html2pdf,
    DateFormat,
    rootReactDom,
    isGTscreenWidth,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './UserInfoEntity.js';

import XZTLOGO from '../../images/logo-head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

const Option = Select.Option;
const MODULENAME = CNF.navItems[1].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[1].ptn;

/**
 * 显示供应商信息
 * @param {*} props 
 * @returns 
 */
const UserInfo = (props) => {
    const [propsState, setPropsState] = useState(props);
    const cancel = () => { setPropsState(false); };
    const printer = () => {
        var printContents = document.getElementById('user-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('user-info-id', props.record.number, ''); };

    useEffect(() => {
        setPropsState(props);
    }, [props]);
    return (
        <>
            <Modal
                width={820}
                style={{ top: 0 }}
                // title={props.record.name}
                closable={false}
                open={propsState.isModalOpen}
                keyboard={true}
                maskClosable={true}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height='45px' alt='新致腾' /></Col>
                            {
                                props.preGroup === 'xzt' ? <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt='新致腾' /></Col> : ''
                            }
                        </Row>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24'><h2>员工信息表</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>姓名:</td><td colSpan='8' style={{ width: 220 }}>{props.record.displayname}</td>
                                    <td colSpan='3' style={{ width: 120 }}>性别:</td><td colSpan='8' style={{ width: 240 }}>{props.record.sex}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>手机:</td><td colSpan='8' style={{ width: 220 }}>{props.record.phone}</td>
                                    <td colSpan='3' style={{ width: 120 }}>邮箱:</td><td colSpan='8' style={{ width: 240 }}>{props.record.email}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>学历:</td><td colSpan='8' style={{ width: 220 }}>{props.record.edu_background}</td>
                                    <td colSpan='3' style={{ width: 120 }}>能力类型:</td><td colSpan='8' style={{ width: 240 }}>{props.record.ability_type}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 140 }}>出生日期:</td><td colSpan='8' style={{ width: 220 }}>{props.record.birth_date}</td>
                                    <td colSpan='3' style={{ width: 120 }}>身份证号:</td><td colSpan='8' style={{ width: 240 }}>{props.record.idcard}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>入职日期:</td><td colSpan='8' style={{ width: 220 }}>{props.record.entry_date}</td>
                                    <td colSpan='3' style={{ width: 140 }}>员工编号:</td><td colSpan='8' style={{ width: 240 }}>{props.record.number}</td>
                                </tr>
                                <tr>
                                    <td colSpan='5' style={{ width: 120 }}>部门:</td><td colSpan='8' style={{ width: 220 }}>{props.record.department}</td>
                                    <td colSpan='3' style={{ width: 140 }}>岗位:</td><td colSpan='8' style={{ width: 240 }}>{props.record.job}</td>
                                </tr>
                                <tr><td colSpan='5' style={{ width: 120 }}>公司:</td><td colSpan='19' style={{ width: 600 }}>{props.record.company}</td></tr>
                                <tr><td colSpan='5' style={{ width: 120 }}>住址:</td><td colSpan='19' style={{ width: 600 }}>{props.record.address}</td></tr>
                                <tr><td colSpan='5' style={{ width: 120 }}>备注:</td><td colSpan='19' style={{ width: 600 }}>
                                    {props.record.description && props.record.description.split('\n').map((item) => {
                                        return <p style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </>
    );
};

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
        }
    }
    update = (record) => { this.props.setIsModalOpen(true, record); }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        switch (action) {
            case CNF.actionName.UPDATE:
                this.update(record);
                break;
            default:
                break;

        }
    }

    /**
     * 显示员工信息
     * @param {*} record 
     */
    showUserInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <UserInfo
                preGroup={this.props.preGroup}
                isModalOpen={true}
                record={record}
            />);
    }

    render() {
        const columns = [
            { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
            {
                title: '姓名', key: 'displayname', width: 100, fixed: 'left',
                render: (record) => <Button
                    color='primary'
                    variant='link'
                    style={{ padding: 0, border: 0, height: 22 }}
                    onClick={() => { this.showUserInfo(record); }}>{record.displayname}</Button>
            },
            { title: '电话', dataIndex: 'phone', key: 'phone', width: 130, },
            { title: '邮箱', dataIndex: 'email', key: 'email', width: 250, },
            { title: '身份证', dataIndex: 'idcard', key: 'idcard', width: 200, },
            { title: '性别', dataIndex: 'sex', key: 'sex', width: 80, },
            { title: '出生日期', dataIndex: 'birth_date', key: 'birth_date', width: 100, },
            { title: '年龄', dataIndex: 'age', key: 'age', width: 80, },
            { title: '能力类型', dataIndex: 'ability_type', key: 'ability_type', width: 100, },
            { title: '学历', dataIndex: 'edu_background', key: 'edu_background', width: 120, },
            { title: '部门', dataIndex: 'department', key: 'department', width: 150, },
            { title: '岗位', dataIndex: 'job', key: 'job', width: 180, },
            { title: '公司', dataIndex: 'company', key: 'company', width: 300, },
            { title: '入职时间', dataIndex: 'entry_date', key: 'entry_date', width: 100, },
            { title: '住址', dataIndex: 'address', key: 'address', width: 400, },
            { title: '员工编号', dataIndex: 'number', key: 'number', width: 120, },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: 100, },
            { title: '状态', dataIndex: 'status', key: 'status', fixed: 'right', width: CNF.tableStatusColumnWidth, },
            {
                title: '', key: 'operation', width: CNF.tableOperationColumnWidth, fixed: 'right',
                render: (record) => GetDropdownActionName(this.props.btnLists, MODULENAME_PTN, record, this.operation)
            }
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: winWidth }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            orgInfosLists: [],
            orgInfoULID: '',
            displayname: '',
            phone: '',
            email: '',
            orgStructureOrgULID: '',
            orgStructureJobULID: '',
            abilityType: '',
            eduBackground: '',
            status: CNF.status[0].value,
        }
    }
    setIsModalOpen = (value, record) => { this.setState({ isModalOpen: value, record: record }); }
    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeOrgInfoULID = (value) => { this.setState({ orgInfoULID: value }); this.search(); }
    changeDisplayname = (e) => { this.setState({ displayname: e.target.value }); this.search(); }
    changePhone = (e) => { this.setState({ phone: e.target.value }); this.search(); }
    changeEmail = (e) => { this.setState({ email: e.target.value }); this.search(); }
    changeOrgStructureOrgULID = (value, params) => { this.setState({ orgStructureOrgULID: value, sid: params.sid, }); this.search(); }
    changeOrgStructureJobULID = (value) => { this.setState({ orgStructureJobULID: value });; this.search(); }
    changeAbilityType = (value) => { this.setState({ abilityType: value ? value : '' }); this.search(); }
    changeEduBackground = (value) => { this.setState({ eduBackground: value ? value : '' }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /**
     * 获取组织信息下拉列表
     */
    getOrgInfoLists = () => {
        const _this = this;
        $.ajax({
            url: `${CNF.api}org/infos?rss=list`,
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({ orgInfosLists: data.dat });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 获取上级组织架构下拉列表
     */
    getOrgStructuresLists = () => {
        const _this = this;
        const params = {
            'rss': 'list',
            'org_info_ulid': this.state.orgInfoULID,
            'status': CNF.status[0].value,
        };
        $.ajax({
            url: `${CNF.api}org/structures${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({ orgStructuresLists: data.dat })
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'rss': 'page',
            'displayname': this.state.displayname,
            'phone': this.state.phone,
            'org_structure_org_ulid': this.state.orgStructureOrgULID,
            'org_structure_job_ulid': this.state.orgStructureJobULID,
            'ability_type': this.state.abilityType,
            'edu_background': this.state.eduBackground,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}user/infos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
    * 导出 Excel
    */
    export = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '员工信息-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '员工信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '姓名',
                    '电话',
                    '邮箱',
                    '身份证',
                    '性别',
                    '出生日期',
                    '年龄',
                    '能力类型',
                    '学历',
                    '部门',
                    '岗位',
                    '公司',
                    '住址',
                    '入职时间',
                    '员工编号',
                    '状态',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出明细
     */
    exportObtain() {
        const _this = this
        const params = {
            'rss': 'page',
            'displayname': this.state.displayname,
            'phone': this.state.phone,
            'org_structure_org_ulid': this.state.orgStructureOrgULID,
            'org_structure_job_ulid': this.state.orgStructureJobULID,
            'ability_type': this.state.abilityType,
            'edu_background': this.state.eduBackground,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}user/infos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['uid'];
                            delete item['username'];
                            delete item['surname'];
                            delete item['name'];
                            delete item['org_info_ulid'];
                            delete item['org_structure_org_ulid'];
                            delete item['org_structure_job_ulid'];
                            delete item['leave_date'];
                            delete item['create_username'];
                            delete item['create_displayname'];
                            delete item['create_time'];
                            delete item['update_time'];
                            d.push(item);
                        }
                        _this.export(d);
                    } else {
                        _this.export([]);
                    }
                } else {
                    message.error(data.msg);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getOrgInfoLists();
        this.getOrgStructuresLists();
        this.getLists();
    }

    render() {
        return (
            <>
                <div>
                    <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                        {
                            this.state.orgInfosLists && this.state.orgInfosLists.length > 1 ? <Col span={isGTscreenWidth ? 4 : 5}>
                                <Select
                                    value={this.state.orgInfoULID}
                                    style={{ width: '100%' }}
                                    onChange={this.changeOrgInfoULID}
                                    disabled={this.state.loading}
                                >
                                    <Option key='请选择公司' value=''>请选择公司</Option>
                                    {
                                        this.state.orgInfosLists && this.state.orgInfosLists.length && this.state.orgInfosLists.map((item) => {
                                            return <Option key={item['ulid']} value={item['ulid']}>{item['name']}</Option>
                                        })
                                    }
                                </Select>
                            </Col> : ''
                        }
                        <Col span={isGTscreenWidth ? 3 : 4} style={{ marginLeft: this.state.orgInfosLists && this.state.orgInfosLists.length > 1 ? 5 : 0 }}>
                            <Input
                                onChange={this.changeDisplayname}
                                placeholder='姓名'
                                value={this.state.displayname}
                            />
                        </Col>
                        <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                            <Input
                                onChange={this.changePhone}
                                placeholder='电话'
                                value={this.state.phone}
                            />
                        </Col>
                        <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                            <Input
                                onChange={this.changeEmail}
                                placeholder='邮箱'
                                value={this.state.email}
                            />
                        </Col>
                        <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                            <Select
                                allowClear
                                placeholder='部门'
                                style={{ width: '100%' }}
                                onChange={this.changeOrgStructureOrgULID}
                            >
                                {
                                    this.state.orgStructuresLists && this.state.orgStructuresLists.length && this.state.orgStructuresLists.map((item) => {
                                        //  决策类和组织类
                                        if (parseInt(item['org_function_type']) !== parseInt(CNF.orgFunctionTypes[2].value)) {
                                            return <Option key={item['ulid']} sid={item['sid']} value={item['ulid']}>{item['title']}</Option>
                                        }
                                        return null;
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                            <Select
                                allowClear
                                placeholder='岗位'
                                style={{ width: '100%' }}
                                onChange={this.changeOrgStructureJobULID}
                            >
                                {
                                    this.state.orgStructuresLists && this.state.orgStructuresLists.length && this.state.orgStructuresLists.map((item) => {
                                        //  岗位类
                                        if (parseInt(item['org_function_type']) === parseInt(CNF.orgFunctionTypes[2].value)) {
                                            if (this.state.sid) {
                                                return this.state.sid === item['up_sid'] ? <Option key={item['ulid']} value={item['ulid']}>{item['title']}</Option> : null;
                                            }
                                            return <Option key={item['ulid']} value={item['ulid']}>{item['title']}</Option>
                                        }
                                        return null;
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                            <Select
                                allowClear
                                placeholder='能力类型'
                                style={{ width: '100%' }}
                                onChange={this.changeAbilityType}
                            >
                                {
                                    CNF.abilityTypes && CNF.abilityTypes.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                            <Select
                                allowClear
                                placeholder='学历'
                                style={{ width: '100%' }}
                                onChange={this.changeEduBackground}
                            >
                                {
                                    CNF.eduBackgrounds && CNF.eduBackgrounds.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                            <Select
                                allowClear
                                placeholder='状态'
                                value={this.state.status}
                                style={{ width: '100%' }}
                                onChange={this.changeStatus}
                            >
                                {
                                    CNF.status && CNF.status.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                            {
                                this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                    <Button
                                        title={CNF.actionName.EXPORT + MODULENAME}
                                        color='primary'
                                        variant='solid'
                                        icon={<ExportOutlined />}
                                        onClick={() => {
                                            this.exportObtain();
                                        }}>
                                        {CNF.actionName.EXPORT}
                                    </Button>
                                ) : ''
                            }
                        </Space>
                        <Entity
                            policy={this.props.policy}
                            isModalOpen={this.state.isModalOpen}
                            record={this.state.record}
                            orgInfosLists={this.state.orgInfosLists}
                            setIsModalOpen={this.setIsModalOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Lists
                                preGroup={this.props.preGroup}
                                btnLists={this.props.btnLists}
                                dataLists={this.state.dataLists}
                                currentIndex={this.state.currentIndex}
                                pageCount={this.state.pageCount}
                                changeIndex={this.changeIndex}
                                setIsModalOpen={this.setIsModalOpen}
                                isRefresh={this.isRefresh}
                            />
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default CPT